import { Prop } from '@typegoose/typegoose'
import { ObjectId } from './ObjectId'

export class RelatedEntityObjectId {
  @Prop({ type: ObjectId, required: true, default: () => new ObjectId() })
  _id: string
}
